module.exports = new __parcel__URL__("folder_space.4db7be29.gif").toString();